<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">
  <img src="assets/img/svg/esmart-logo.svg" alt="EMP Logo" />

  <img src="assets/img/svg/emp-robot.svg" width="70px" height="112px" />

  <h3>{{ 'LOGIN' | translate | uppercase }}</h3>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
    <mat-label>{{ 'EMAIL' | translate }}</mat-label>
    <input matInput formControlName="login" type="text" autofocus="autofocus" />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
    <mat-label>{{ 'PASSWORD' | translate }}</mat-label>
    <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" autocomplete="off" />
    <button
      type="button"
      class="es-btn-icon"
      matSuffix
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hidePassword"
      (click)="hidePassword = !hidePassword"
    >
      <span class="material-symbols-rounded-l">
        {{ hidePassword ? 'visibility' : 'visibility_off' }}
      </span>
    </button>
  </mat-form-field>

  <button [disabled]="form.invalid" class="es-btn es-btn-lg es-btn-accented" type="submit">
    {{ 'LOGIN' | translate | uppercase }}
  </button>

  <a class="underline" routerLink="/reset-password">
    {{ 'LOGIN__FORGOT_PASSWORD' | translate }}
  </a>
</form>
